import PropTypes from 'prop-types'
import { sectionMappingPropType } from './section-mapping-prop-type'

/**
 * Proptype that represents an array of mappings (each a mapping of a collection of items to a particular section)
 * @typedef {Array.<sectionMappingPropType>}  sectionMappingsPropType
 */
export const sectionMappingsPropType = PropTypes.arrayOf(sectionMappingPropType)
